import React from "react";
import { DraftingCompass, Network, House, ArrowUpRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const features = [{
  title: "Alles aus einer Hand",
  subtitle: "Bis zu 40% mehr Eigenverbrauch",
  description: "Durch intelligente Vernetzung von PV, Speicher und Verbrauchern holen Sie das Maximum aus Ihrer Anlage heraus.",
  icon: DraftingCompass
}, {
  title: "Keine isolierten Einzellösungen",
  subtitle: "Amortisation in 3–7 Jahren",
  description: "Unsere Systeme rechnen sich – und danach profitieren Sie langfristig von niedrigeren Energiekosten.",
  icon: Network
}, {
  title: "Optimiert auf Ihr gesamtes Haus",
  subtitle: "1 Ansprechpartner für alles",
  description: "Von der Planung bis zur Inbetriebnahme – kein Koordinationsaufwand, keine Missverständnisse zwischen Gewerken.",
  icon: House
}, {
  title: "Zukunftssicher & erweiterbar",
  subtitle: "Jederzeit erweiterbar",
  description: "Unsere Systeme wachsen mit Ihren Anforderungen – heute Smart Home, morgen Energiemanagement, übermorgen E-Mobilität.",
  icon: ArrowUpRight
}];
export default function WarumS2Automation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="warums2automation" ref={ref} className="bg-background text-foreground py-24 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className={cn("max-w-3xl mb-16 transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-4xl md:text-5xl font-bold text-primary tracking-tight mb-4">
            Warum S2 Automation?
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl">Technik, die nicht nur funktioniert – sondern perfekt zusammenspielt.<div>Wir verbinden Gebäudeautomation, Energie und Steuerungstechnik zu einem intelligenten Gesamtsystem.</div></p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, i) => <div key={i} data-index={i} className={cn("transition-all duration-700 ease-out transform h-full", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <Card className="h-full bg-white/[0.02] border-white/10 hover:border-primary/50 hover:bg-white/[0.04] transition-colors duration-300 group">
                <CardHeader className="pb-4">
                  <div className="mb-6 inline-flex items-center justify-center size-12 rounded-lg bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                    <feature.icon strokeWidth={1.5} className="size-6" />
                  </div>
                  <CardTitle className="text-xl font-sans font-semibold text-foreground">
                    {feature.title}
                  </CardTitle>
                  <div className="text-sm font-mono text-primary mt-1">
                    {feature.subtitle}
                  </div>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-muted-foreground leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}